import { createDeferred, createEffect, on } from "solid-js";
import type { DeferredOptions } from "solid-js/types/reactive/signal";

/**
 * @description fires callback ones when passed down signal have truth value
 * @param val
 * @param effect
 */
export const useNonNullableOnce = <ValType>(
	val: () => ValType,
	effect: (val: NonNullable<ValType>) => void
) => {
	createEffect<boolean>((prev) => {
		if (prev) return true;
		const value = val();

		if (!value) return false;
		effect(value);

		return true;
	}, false);
};

/**
 * @description fires callback when passed down signal have updated
 * @param val
 * @param effect
 * @param options
 */
export const useOnDeferredUpdate = <ValType>(
	val: () => ValType,
	effect: (val: ValType) => void,
	options?: DeferredOptions<ValType>
) => {
	const deffred = createDeferred(val, options);
	createEffect(
		on(deffred, (val) => {
			effect(val);
		})
	);
};
